import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShare2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "share-2" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21.75,5.25H13.5a3,3,0,0,0-3,3V12"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "17.25 9.75 21.75 5.25 17.25 0.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18.75,14.25v7.5a1.5,1.5,0,0,1-1.5,1.5H3.75a1.5,1.5,0,0,1-1.5-1.5v-12a1.5,1.5,0,0,1,1.5-1.5H6"
		})
	]
});
export default SvgShare2;
